import React, { useState } from "react";
import "./Contact_Us.css";
import Common_Title_1 from "../common/common_components/common_title_1/Common_Title_1";
import {
  faLocationDot,
  faMapLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faLinkedinIn,
  faTwitter,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Orange_Btn from "../common/common_btn/orange_btn/Orange_Btn";
import Contact_Us_Form from "./contact_us_form/Contact_Us_Form";
import Our_Centers from "./our_centers/Our_Centers";
import Whatsapp_Lottie from "../animation/whatsapp_lottie/Whatsapp_Lottie";

const Contact_Us = () => {
  return (
    <section className="Contact_Us">
      <Contact_Us_Form />
      <Our_Centers />

      <div className="container">
        <div
          className="whatsapp_lottie_holder"
          onClick={() => window.open("https://web.whatsapp.com/", "_blank")}
          style={{ cursor: "pointer" }}
        >
        
        </div>
      </div>
    </section>
  );
};

export default Contact_Us;
